import {
  addCpfMask,
  convertDateToBrazilFormat,
  generateAvatarInitialsImage,
  getReadableDuration,
} from '@repo/ui';
import { GET_PAGINATED_ORGANIZATION_ACTIVE_TCES_COLUMNS } from 'domain/models';
import { GetPaginatedOrganizationActiveTcesUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

export const makeActiveTcesColumns = (): TableColumn<
  GetPaginatedOrganizationActiveTcesUseCaseInterface.Result['tces'][number]
>[] => {
  return [
    {
      name: 'Estudante',
      width: '20%',
      sortable: true,
      sortField: GET_PAGINATED_ORGANIZATION_ACTIVE_TCES_COLUMNS.NAME,
      wrap: true,
      selector: (row) => row.name,
      cell: ({ photo, name, cpf }) => (
        <div className="d-flex align-items-center gap-2">
          <img
            src={photo || generateAvatarInitialsImage(name)}
            className="rounded-circle avatar-xs user-profile-image"
          />
          <div>
            <p className="m-0">{name}</p>
            <p className="m-0 text-muted">{addCpfMask(cpf)}</p>
          </div>
        </div>
      ),
    },
    {
      name: 'Grupo',
      selector: (row) => row.groupName,
      sortField: GET_PAGINATED_ORGANIZATION_ACTIVE_TCES_COLUMNS.GROUP_NAME,
      wrap: true,
      sortable: true,
      cell: ({ groupName, groupCode }) => `${groupName} - ${groupCode}`,
    },
    {
      name: 'Local de Estágio',
      selector: (row) => row.internshipLocationName,
      sortField:
        GET_PAGINATED_ORGANIZATION_ACTIVE_TCES_COLUMNS.INTERNSHIP_LOCATION_NAME,
      wrap: true,
      sortable: true,
    },
    {
      name: 'Período de Estágio',
      selector: (row) => row.duration,
      sortField: GET_PAGINATED_ORGANIZATION_ACTIVE_TCES_COLUMNS.PERIOD,
      wrap: true,
      sortable: true,
      cell: ({ startsAt, endsAt, duration }) => {
        return (
          <div>
            <p className='mb-1'>
              {startsAt ? convertDateToBrazilFormat(startsAt) : '--'} -{' '}
              {endsAt ? convertDateToBrazilFormat(endsAt) : '--'}
            </p>
            <p className="m-0">
              {duration ? (duration > 1 ? `${duration} meses` : '1 mês') : '--'}
            </p>
          </div>
        );
      },
    },
    {
      name: 'Tempo de Estágio',
      selector: (row) => row.updatedAt,
      wrap: true,
      cell: ({ startsAt }) => {
        if (!startsAt) {
          return <div>--</div>;
        }

        return (
          <div>
            <p>{getReadableDuration(startsAt, new Date())}</p>
          </div>
        );
      },
    },
  ];
};
